module.exports = __webpack_public_path__ + "img/q10.82c52450.png";